// @flow
import type { Saga } from "redux-saga";
import Cookies from "js-cookie";

import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "../../actions";
import { Api } from "../../../utils";
import { logoutNRLAccount } from '../../../utils/auth';

const addSessionCookie = session_id => {
	if (process.env.NODE_ENV !== 'production') {
		Cookies.set('session', session_id, { expires: 30 });
	}
};

const removeSessionCookie = () => {
	if (process.env.NODE_ENV !== 'production') {
		Cookies.remove("session");
	}
};

type FetchUserAction = {
	payload: Object
};

function* fetchUserSaga(action: FetchUserAction): Saga<void> {
	try {

		const {
			result: user,
			errors
		} = yield call(Api.User.get);

		if (errors.length) {
			throw new Error(errors[0].text);
		}

		yield put(actions.fetchUserSuccess(user));
	}
	catch (error) {
		console.log(error);
		yield put(actions.fetchUserFailed(error.message));
	}
}

type PostSSOActionType = {
	type: string,
	payload: {
		code: string,
		redirect_url: string
	}
};

const postSSOSaga = function* postSSOSaga(
	action: PostSSOActionType
): Saga<void> {
	try {
		const { code, redirect_url } = action.payload,
			{
				result: { identity_token },
				errors
			} = yield call(Api.Auth.loginSSO, { code, redirect_url });

		if (errors.length) {
			throw new Error(errors[0].text);
		}

		yield put(actions.postUserLogin({ identity_token }));

	}
	catch (error) {
		console.log(error);
		removeSessionCookie();
		yield put(actions.postSSOFailed(error.message));
	}
};

type UserLoginAction = {
	payload: {
		identity_token: string
	}
};

const postUserLoginSaga = function* postUserLoginSaga(
	action: UserLoginAction
): Saga<void> {
	try {
		const { identity_token } = action.payload,
			{
				result: { user, session_id },
				errors
			} = yield call(Api.Auth.login, { identity_token });

		//TODO: add error handler
		if (errors.length) {
			console.log(errors);
			throw new Error(errors[0].text);
		}
		else {
			addSessionCookie(session_id);
			yield put(actions.postUserLoginSuccess({ user, session_id }));
		}
	}
	catch (error) {
		console.log(error);
		removeSessionCookie();
		yield put(actions.postUserLoginFailed(error.message));
	}
};

const userLogoutSaga = function* postUserLogoutSaga(): Saga<void> {
	try {
		const { success, errors } = yield call(Api.Auth.logout);

		removeSessionCookie();

		//TODO: add error handler
		if (!success) {
			console.log(errors);
			throw new Error(errors[0].text);
		}
		localStorage.clear();
		logoutNRLAccount();
		// yield put(actions.userLogoutSuccess());
	}
	catch (error) {
		console.log(error);
		yield put(actions.userLogoutFailed(error.message));
	}
};

export function* userRootSaga(): Saga<void> {
	yield takeLatest(actions.fetchUser, fetchUserSaga);
	yield takeLatest(actions.postSSO, postSSOSaga);
	yield takeLatest(actions.postUserLogin, postUserLoginSaga);
	yield takeLatest(actions.userLogout, userLogoutSaga);
}


// WEBPACK FOOTER //
// ./src/modules/sagas/user/index.js